import { render } from "./radioPictureSelectAttributeEditor.vue?vue&type=template&id=ac8c4050"
import script from "./radioPictureSelectAttributeEditor.vue?vue&type=script&lang=js"
export * from "./radioPictureSelectAttributeEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__